// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileTermsOfService_root__317MG","lastUpdated":"MobileTermsOfService_lastUpdated__1wbD3","disc":"MobileTermsOfService_disc__21aWB"};